import {Action} from "../../../actions/actions";
import {ConfigurationsActionTypes} from "../actions/actionTypes";

export interface RTPProfilesOrder {
    key: string;
    direction: string;
}

export interface RTPProfileSetting {
    description: string;
    game: any;
    gameInstanceIdentifiers: number[];
    identifier: number;
    originalProfile: string | number;
    profile: string | number;
}

export interface RTPProfilesState {
    defaultProfile: any;
    previousDefaultProfile: number | null;
    loading: boolean;
    profiles: any[];
    settings: RTPProfileSetting[];
    order: RTPProfilesOrder;
}

const defaultState: RTPProfilesState = {
    defaultProfile: null,
    previousDefaultProfile: null,
    loading: false,
    profiles: [],
    settings: [],
    order: {
        key: "description",
        direction: "asc"
    }
};

export function rtpProfiles(
    state: RTPProfilesState = defaultState,
    action: Action
): RTPProfilesState {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_RTP_PROFILES:
            return {
                ...state,
                loading: true
            };
        case ConfigurationsActionTypes.GET_RTP_PROFILES_SUCCESS:
            return {
                ...state,
                defaultProfile: action.payload.defaultProfile,
                loading: false,
                profiles: action.payload.profiles,
                settings: action.payload.settings
            };
        case ConfigurationsActionTypes.GET_RTP_PROFILES_FAIL:
            return {
                ...state,
                loading: false
            };
        case ConfigurationsActionTypes.REORDER_RTP_PROFILES_SUCCESS:
            return {
                ...state,
                order: action.payload
            };
        case ConfigurationsActionTypes.UPDATE_RTP_PROFILE:
            return {
                ...state,
                settings: state.settings.map(setting =>
                    setting.identifier === action.payload.gameIdentifier
                        ? {
                              ...setting,
                              profile: action.payload.profile
                          }
                        : setting
                )
            };
        case ConfigurationsActionTypes.SET_PREVIOUS_RTP_DEFAULT_PROFILE:
            return {
                ...state,
                previousDefaultProfile: action.payload
            };
        case ConfigurationsActionTypes.CLEAR_CONFIGURATION:
            return defaultState;
        default:
            return state;
    }
}
